import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class StorageService {

  constructor() { }

  getObject(storageKey: string): any {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '');
    } catch (e) {
      return null;
    }
  }

  setObject(storageKey: string, obj: any) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(obj));
    } catch (e) {
      console.error(e);
    }
  }

  removeObjects(keys: string[]) {
    for (let key of keys) {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    }
  }
}